import { render, staticRenderFns } from "./EditorLoading.vue?vue&type=template&id=2588516a&scoped=true&"
var script = {}
import style0 from "./EditorLoading.vue?vue&type=style&index=0&id=2588516a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2588516a",
  null
  
)

export default component.exports